import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::bulk
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:211
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
export const bulk = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: bulk.url(args, options),
    method: 'patch',
})

bulk.definition = {
    methods: ["patch"],
    url: '/app/agents/{agent}/mcp/{mcpServer}/tools',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::bulk
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:211
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
bulk.url = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            agent: args[0],
            mcpServer: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
        mcpServer: typeof args.mcpServer === 'object'
        ? args.mcpServer.id
        : args.mcpServer,
    }

    return bulk.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace('{mcpServer}', parsedArgs.mcpServer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::bulk
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:211
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
bulk.patch = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: bulk.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::bulk
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:211
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
const bulkForm = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulk.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Mcp\McpServerController::bulk
* @see app/Http/Controllers/Admin/Mcp/McpServerController.php:211
* @route '/app/agents/{agent}/mcp/{mcpServer}/tools'
*/
bulkForm.patch = (args: { agent: string | { id: string }, mcpServer: string | number | { id: string | number } } | [agent: string | { id: string }, mcpServer: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulk.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

bulk.form = bulkForm

const tools = {
    bulk: Object.assign(bulk, bulk),
}

export default tools